/**
 * Shared constants for HappyDoc Bridge OAuth flow.
 */

/** Required OAuth parameters for bridge authentication flow. */
export const BRIDGE_REQUIRED_PARAMS = ["redirect_uri", "code_challenge", "code_challenge_method"] as const;
